import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { TranslationService } from '../../shared/index';

import { RevenueService } from '../../revenue/shared/revenue.service';
import { AgingSummaryRow } from '../../revenue/shared/aging-summary.model';

@Component({
  selector: 'wl-dashboard-revenue-dues-aging',
  templateUrl: 'dues-aging.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [RevenueService],
  styleUrls: ['dues-aging.component.less'],
    standalone: false
})
export class DashboardDuesAgingComponent implements OnInit {
  private _translationService: TranslationService;
  private _revenueService: RevenueService;

  public agingSummary: Array<AgingSummaryRow>;
  public agingTotals: AgingSummaryRow;
  public isLoading: boolean;

  public constructor(translationService: TranslationService, revenueService: RevenueService) {
    this._translationService = translationService;
    this._revenueService = revenueService;
    this.isLoading = true;
  }

  ngOnInit() {
    this.agingSummary = new Array<AgingSummaryRow>();
    this.agingTotals = new AgingSummaryRow();

    this._revenueService.getDuesAgingSummary().then((data: Array<AgingSummaryRow>) => {
      for (var i = 0; i < data.length; i++) {
        switch (i) {
          case 0: {
            data[i].Title = this._translationService.getInstant('dashboard.revenue.aging.current');
            break;
          }
          case 1: {
            data[i].Title = this._translationService.getInstant('dashboard.revenue.aging.31-to-60');
            break;
          }
          case 2: {
            data[i].Title = this._translationService.getInstant('dashboard.revenue.aging.61-to-90');
            break;
          }
          case 3: {
            data[i].Title = this._translationService.getInstant('dashboard.revenue.aging.91-to-120');
            break;
          }
          case 4: {
            data[i].Title = this._translationService.getInstant('dashboard.revenue.aging.121Plus');
            break;
          }
        }
      }

      this.agingSummary = data;
      this.agingTotals = this.agingSummary.splice(5, 1)[0];

      this.isLoading = false;
    });
  }
}
